import { useState } from 'react';

import useStyles from './styles';
import { ISymbolsProps } from './types';
import SymbolsZeroResult from './SymbolsZeroResult';
import Symbol from './Symbol';

function Symbols({
  symbolsList,
  stickyOffset,
  chooseSymbol,
  displayCategory = true,
}: ISymbolsProps) {
  const styles = useStyles();
  const [hoveredNr, setHoveredNr] = useState(0);
  const displayTooltip = hoveredNr < 5;

  const handleMouseEnter = () => {
    if (hoveredNr < 7) {
      setHoveredNr((prev) => prev + 1);
    }
  };

  if (!displayCategory) {
    const symbolsWithoutCategory = [...symbolsList.map(({ symbols }) => symbols).flat(1)];

    const displayZeroResults = symbolsWithoutCategory.length === 0;

    if (displayZeroResults) {
      return <SymbolsZeroResult />;
    }

    return (
      <ul className={styles.emojis}>
        {symbolsWithoutCategory.map((symbol, index) => (
          <Symbol
            key={index}
            symbol={symbol}
            hover={handleMouseEnter}
            click={chooseSymbol}
            displayTooltip={displayTooltip}
          />
        ))}
      </ul>
    );
  }

  return (
    <>
      {symbolsList.map(({ symbols, category }) => (
        <div key={category} className={styles.container}>
          <div className={styles.category} style={{ top: stickyOffset - 20 }}>
            <span>{category}</span>
          </div>

          <ul className={styles.emojis}>
            {symbols.map((symbol) => (
              <Symbol
                symbol={symbol}
                key={symbol.name}
                click={chooseSymbol}
                hover={handleMouseEnter}
                displayTooltip={displayTooltip}
              />
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}

export default Symbols;
